import type { ComponentPropsWithRef, ElementType } from 'react';

import { tv, type VariantProps } from '@/lib/tv';

export const layoutVariants = tv({
  variants: {
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      baseline: 'items-baseline',
      stretch: 'items-stretch',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    gap: {
      0: 'gap-0',
      0.5: 'gap-0.5',
      1: 'gap-1',
      1.5: 'gap-1.5',
      2: 'gap-2',
      2.5: 'gap-2.5',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      8: 'gap-8',
      10: 'gap-10',
      12: 'gap-12',
      16: 'gap-16',
      20: 'gap-20',
    },
    wrap: {
      wrap: 'flex-wrap',
      nowrap: 'flex-nowrap',
      'wrap-reverse': 'flex-wrap-reverse',
    },
    p: {
      0: 'p-0',
      0.5: 'p-0.5',
      1: 'p-1',
      1.5: 'p-1.5',
      2: 'p-2',
      2.5: 'p-2.5',
      3: 'p-3',
      4: 'p-4',
      5: 'p-5',
      6: 'p-6',
      8: 'p-8',
      10: 'p-10',
      12: 'p-12',
      16: 'p-16',
      20: 'p-20',
    },
    px: {
      0: 'px-0',
      0.5: 'px-0.5',
      1: 'px-1',
      1.5: 'px-1.5',
      2: 'px-2',
      2.5: 'px-2.5',
      3: 'px-3',
      4: 'px-4',
      5: 'px-5',
      6: 'px-6',
      8: 'px-8',
      10: 'px-10',
      12: 'px-12',
      16: 'px-16',
      20: 'px-20',
    },
    py: {
      0: 'py-0',
      0.5: 'py-0.5',
      1: 'py-1',
      1.5: 'py-1.5',
      2: 'py-2',
      2.5: 'py-2.5',
      3: 'py-3',
      4: 'py-4',
      5: 'py-5',
      6: 'py-6',
      8: 'py-8',
      10: 'py-10',
      12: 'py-12',
      16: 'py-16',
      20: 'py-20',
    },
    pt: {
      0: 'pt-0',
      0.5: 'pt-0.5',
      1: 'pt-1',
      1.5: 'pt-1.5',
      2: 'pt-2',
      2.5: 'pt-2.5',
      3: 'pt-3',
      4: 'pt-4',
      5: 'pt-5',
      6: 'pt-6',
      8: 'pt-8',
      10: 'pt-10',
      12: 'pt-12',
      16: 'pt-16',
      20: 'pt-20',
    },
    pr: {
      0: 'pr-0',
      0.5: 'pr-0.5',
      1: 'pr-1',
      1.5: 'pr-1.5',
      2: 'pr-2',
      2.5: 'pr-2.5',
      3: 'pr-3',
      4: 'pr-4',
      5: 'pr-5',
      6: 'pr-6',
      8: 'pr-8',
      10: 'pr-10',
      12: 'pr-12',
      16: 'pr-16',
      20: 'pr-20',
    },
    pb: {
      0: 'pb-0',
      0.5: 'pb-0.5',
      1: 'pb-1',
      1.5: 'pb-1.5',
      2: 'pb-2',
      2.5: 'pb-2.5',
      3: 'pb-3',
      4: 'pb-4',
      5: 'pb-5',
      6: 'pb-6',
      8: 'pb-8',
      10: 'pb-10',
      12: 'pb-12',
      16: 'pb-16',
      20: 'pb-20',
    },
    pl: {
      0: 'pl-0',
      0.5: 'pl-0.5',
      1: 'pl-1',
      1.5: 'pl-1.5',
      2: 'pl-2',
      2.5: 'pl-2.5',
      3: 'pl-3',
      4: 'pl-4',
      5: 'pl-5',
      6: 'pl-6',
      8: 'pl-8',
      10: 'pl-10',
      12: 'pl-12',
      16: 'pl-16',
      20: 'pl-20',
    },
    m: {
      0: 'm-0',
      0.5: 'm-0.5',
      1: 'm-1',
      1.5: 'm-1.5',
      2: 'm-2',
      2.5: 'm-2.5',
      3: 'm-3',
      4: 'm-4',
      5: 'm-5',
      6: 'm-6',
      8: 'm-8',
      10: 'm-10',
      12: 'm-12',
      16: 'm-16',
      20: 'm-20',
      auto: 'm-auto',
    },
    mx: {
      0: 'mx-0',
      0.5: 'mx-0.5',
      1: 'mx-1',
      1.5: 'mx-1.5',
      2: 'mx-2',
      2.5: 'mx-2.5',
      3: 'mx-3',
      4: 'mx-4',
      5: 'mx-5',
      6: 'mx-6',
      8: 'mx-8',
      10: 'mx-10',
      12: 'mx-12',
      16: 'mx-16',
      20: 'mx-20',
      auto: 'mx-auto',
    },
    my: {
      0: 'my-0',
      0.5: 'my-0.5',
      1: 'my-1',
      1.5: 'my-1.5',
      2: 'my-2',
      2.5: 'my-2.5',
      3: 'my-3',
      4: 'my-4',
      5: 'my-5',
      6: 'my-6',
      8: 'my-8',
      10: 'my-10',
      12: 'my-12',
      16: 'my-16',
      20: 'my-20',
      auto: 'my-auto',
    },
    mt: {
      0: 'mt-0',
      0.5: 'mt-0.5',
      1: 'mt-1',
      1.5: 'mt-1.5',
      2: 'mt-2',
      2.5: 'mt-2.5',
      3: 'mt-3',
      4: 'mt-4',
      5: 'mt-5',
      6: 'mt-6',
      8: 'mt-8',
      10: 'mt-10',
      12: 'mt-12',
      16: 'mt-16',
      20: 'mt-20',
      auto: 'mt-auto',
    },
    mr: {
      0: 'mr-0',
      0.5: 'mr-0.5',
      1: 'mr-1',
      1.5: 'mr-1.5',
      2: 'mr-2',
      2.5: 'mr-2.5',
      3: 'mr-3',
      4: 'mr-4',
      5: 'mr-5',
      6: 'mr-6',
      8: 'mr-8',
      10: 'mr-10',
      12: 'mr-12',
      16: 'mr-16',
      20: 'mr-20',
      auto: 'mr-auto',
    },
    mb: {
      0: 'mb-0',
      0.5: 'mb-0.5',
      1: 'mb-1',
      1.5: 'mb-1.5',
      2: 'mb-2',
      2.5: 'mb-2.5',
      3: 'mb-3',
      4: 'mb-4',
      5: 'mb-5',
      6: 'mb-6',
      8: 'mb-8',
      10: 'mb-10',
      12: 'mb-12',
      16: 'mb-16',
      20: 'mb-20',
      auto: 'mb-auto',
    },
    ml: {
      0: 'ml-0',
      0.5: 'ml-0.5',
      1: 'ml-1',
      1.5: 'ml-1.5',
      2: 'ml-2',
      2.5: 'ml-2.5',
      3: 'ml-3',
      4: 'ml-4',
      5: 'ml-5',
      6: 'ml-6',
      8: 'ml-8',
      10: 'ml-10',
      12: 'ml-12',
      16: 'ml-16',
      20: 'ml-20',
      auto: 'ml-auto',
    },
    grow: {
      0: 'grow-0',
      1: 'grow',
    },
    shrink: {
      0: 'shrink-0',
      1: 'shrink',
    },
    basis: {
      auto: 'basis-auto',
      full: 'basis-full',
      0: 'basis-0',
      '1/2': 'basis-1/2',
      '1/3': 'basis-1/3',
      '2/3': 'basis-2/3',
      '1/4': 'basis-1/4',
      '3/4': 'basis-3/4',
    },
    width: {
      auto: 'w-auto',
      full: 'w-full',
      min: 'w-min',
      max: 'w-max',
      fit: 'w-fit',
    },
    height: {
      auto: 'h-auto',
      full: 'h-full',
      min: 'h-min',
      max: 'h-max',
      fit: 'h-fit',
    },
  },
});

type LayoutVariants = VariantProps<typeof layoutVariants>;

export type PolymorphicLayoutProps<T extends ElementType = 'div'> = {
  as?: T;
} & LayoutVariants &
  Omit<ComponentPropsWithRef<T>, keyof LayoutVariants | 'as'>;
